import { Select } from "@mantine/core";
import { modals } from "@mantine/modals";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { httpPostGraphql } from "shared/api/httpClient";
import { useComposeFormContext } from "shared/components/message/compose/context";
import { useFormState } from "shared/hooks/useFormState";
import { qk } from "shared/utils/qk";
import { graphql } from "src/gql";

export const SenderSelect = () => {
    const { data } = useSuspenseQuery(queries.senders);
    const form = useComposeFormContext();
    const [senderId, setSender] = useFormState(form, "sender.id");

    function handleChange(id: string) {
        const { features, geofilters } = form.getValues().audience;
        if (features.length > 0 || geofilters.length > 0) {
            modals.openConfirmModal({
                title: "Change Sender",
                children: "Changing the sender will remove any drawn or selected regions. Are you sure you want to continue?",
                labels: { confirm: "Change Sender", cancel: "Cancel" },
                onConfirm: () => {
                    form.setFieldValue("audience.features", []);
                    form.setFieldValue("audience.geofilters", []);
                    setSender(id);
                },
            });
            return;
        }

        setSender(id);
    }

    return (
        <Select
            searchable
            required
            label="From"
            data={data?.senders.map(({ id: value, name: label }) => ({ value, label }))}
            value={senderId}
            onChange={(_, { value: id }) => handleChange(id)}
            error={form.getInputProps("sender.id").error}
        />
    );
};

const queries = {
    senders: queryOptions({
        queryKey: qk("compose", "senders"),
        queryFn: () =>
            httpPostGraphql(
                graphql(`
                    query ComposeFormSenders {
                        senders {
                            id
                            name
                        }
                    }
                `),
                {},
            ),
    }),
};
